var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.container,on:{"click":_vm.callDeepLink}},[_c('h4',[_vm._v(_vm._s(_vm.getText))])])}
var staticRenderFns = []

export { render, staticRenderFns }